// Types shared between the api, web, and the host-agent.
//
// The agent collects a snapshot of the host's crontab and posts it to the
// dashboard; the dashboard pre-resolves repos and exposes per-repo views to
// the SPA. Keep these names aligned with the SQL columns to minimise mapping.
export const CRON_COMMAND_TYPES = [
    "pause",
    "resume",
    "run_now",
    "set_schedule",
    "set_wrapped",
];
export const CRON_COMMAND_STATUSES = [
    "pending",
    "applied",
    "failed",
];
//# sourceMappingURL=repos.js.map